export default "__VITE_PUBLIC_ASSET__afeb74ea__"